import { JobAzCheckDialogOnCreateComponent } from '@agent-ds/jobs/components/job-az-check/job-az-check-dialog-on-create/job-az-check-dialog-on-create.component';
import { JobAzCheckDialogBeforeAzComponent } from '@agent-ds/jobs/components/job-az-check/job-az-check-dialog-before-az/job-az-check-dialog-before-az.component';
import { JobAzCheckDialogAfterAz1stComponent } from '@agent-ds/jobs/components/job-az-check/job-az-check-dialog-after-az-1st/job-az-check-dialog-after-az-1st.component';
import { JobAzCheckDialogAfterAz2ndComponent } from '@agent-ds/jobs/components/job-az-check/job-az-check-dialog-after-az-2nd/job-az-check-dialog-after-az-2nd.component';
import { JobAzCheckDialogApplyCompanyChangesComponent } from '@agent-ds/jobs/components/job-az-check/job-az-check-dialog-apply-company-changes/job-az-check-dialog-apply-company-changes.component';
import { JobAzCheckConsultationResultDialogComponent } from '@agent-ds/jobs/components/job-az-check/job-az-check-consultation-result-dialog/job-az-check-consultation-result-dialog.component';
import { JobScreeningInfoCreateDialogComponent } from '@agent-ds/jobs/components/job-screening-info-create-dialog/job-screening-info-create-dialog.component';
import { JobScreeningInfoEditDialogComponent } from '@agent-ds/jobs/components/job-screening-info-edit-dialog/job-screening-info-edit-dialog.component';
import { DialogRef } from '@agent-ds/shared/components/dialog/dialog-ref';
import { PopupControlComponent } from '@agent-ds/shared/components/popup-control/popup-control.component';
import { DashboardType, EnterpriseDepartmentUserType, Job, JobScreeningInfo } from '@agent-ds/shared/interfaces';
import { AFTER_AZ_FLOW_STATUSES, JobAzCheckConsultingInfo, JobAzCheckTiming } from '@agent-ds/shared/interfaces/job-az-check';
import {
  clearFixedLateNightOvertimeCategoryValues,
  clearFixedOvertimeCategoryValues,
  forceFixedOvertimeFeeNoneForDeemedWorkingHours,
  isDeemedWorkingHoursSystemSelected,
} from '../../../../util/job-salary-table';
import { SalaryTableRowsService } from '../../../../services/salary-table-rows.service';
import { FormMeta, GroupMeta, RowMeta, SupplierCallType } from '@agent-ds/shared/models';
import { SafeDatePipe } from '@agent-ds/shared/pipes/safe-date.pipe';
import { AuthService, CompanyApiService, DialogService, DynamicFieldService, JobApiService } from '@agent-ds/shared/services';
import { UserTeamInjectorProvider } from '@agent-ds/shared/services/api/providers/user-team-injector.provider';
import { deepClone } from '@agent-ds/shared/util/util';
import { Component, Input, OnChanges, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

const JOB_AZ_CHECK_IS_RA_CONSULTING_VALUE = 1;
const STATUS_RECRUITING = '募集中';

@Component({
  selector: 'ag-job-detail-tab',
  templateUrl: './job-detail-tab.component.html',
  styleUrls: ['./job-detail-tab.component.scss'],
  providers: [SalaryTableRowsService],
})
export class JobDetailTabComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('addNewSubScreeningInfo', { static: true }) addNewSubScreeningInfoTemplate: TemplateRef<HTMLElement>;
  @Input() job: Job;
  @Input() readonly: boolean;

  private dialogRef: DialogRef;

  headMeta: FormMeta;
  leftMeta: FormMeta;
  rightMeta: FormMeta;
  subScreeningInfoMeta1: FormMeta;
  screeningMeta1: FormMeta;
  screeningMeta2: FormMeta;
  interviewMeta1: FormMeta;
  interviewMeta2: FormMeta;
  remarksMeta: FormMeta;
  remarksMeta1: FormMeta;
  screeningInfoSubGroupMeta: FormMeta;
  customMeta: FormMeta;

  private validityArray = [true, true, true, true, true, true, true, true, true];
  validity = true;

  private fieldSubscription: Subscription;
  private enterpriseDepartmentUsers = {};
  private jobScreeningInfoSubscription: Subscription;
  public jobScreeningInfoList: JobScreeningInfo[] = [];
  private originalStatus: string | null = null;

  get canSave(): boolean {
    if (!this.job) {
      return false;
    }
    return (
      this.validity &&
      !this.isInConsultation(this.job.dynamicData.azConsultingInfoOnCreate) &&
      !this.isInConsultation(this.job.dynamicData.azConsultingInfoBeforeAz) &&
      !this.isInConsultation(this.job.dynamicData.azConsultingInfoAfterAz1st) &&
      !this.isInConsultation(this.job.dynamicData.azConsultingInfoAfterAz2nd)
    );
  }

  get showReflectButton(): boolean {
    if (!this.job || !this.job.dynamicData.jobCompanySharedFormat || this.job.dynamicData.jobCompanySharedFormat === 'excel') {
      // Excelで共有した場合は表示しない
      return false;
    }

    // URLで共有した場合、企業返却済み もしくは RA相談中 のみ表示する
    return !!this.job.dynamicData.jobCompanyAzCheckReturnedAt || this.job.dynamicData.jobCompanyAzCheckIsRaConsulting === JOB_AZ_CHECK_IS_RA_CONSULTING_VALUE;
  }

  get azCheckButtonOnCreateDisplayFlg(): boolean {
    return !this.isAfterAzFlow && this.isAzCheckOnCreate;
  }

  get azCheckButtonBeforeAzDisplayFlg(): boolean {
    return !this.isAfterAzFlow && !this.isAzCheckOnCreate;
  }

  get azCheckButtonAfterAz1stDisplayFlg(): boolean {
    return this.isAfterAzFlow && this.isAzCheckAfterAz1st;
  }

  get azCheckButtonAfterAz2ndDisplayFlg(): boolean {
    return this.isAfterAzFlow && !this.isAzCheckAfterAz1st;
  }

  get isAzCheckAfterAz1st(): boolean {
    if (!this.job) {
      return false;
    }

    // 求人票共有形式が入っていない = 求人票未共有のため作成中のAZチェックである
    return !this.job.dynamicData.jobCompanySharedFormat;
  }

  get isAzCheckOnCreate(): boolean {
    if (!this.job) {
      return false;
    }

    // 求人票共有形式が入っていない = 求人票未共有のため作成中のAZチェックである
    return !this.job.dynamicData.jobCompanySharedFormat || this.originalStatus === '作成中';
  }

  /**
   * 求人ステータスが「募集中」「推薦停止」「終了」のいずれかかどうか。該当する場合、求人チェック/AZ前チェックは
   * afterAz1st/afterAz2ndダイアログ（募集中ルート専用）を使用する。
   */
  private get isAfterAzFlow(): boolean {
    if (!this.job) {
      return false;
    }
    return AFTER_AZ_FLOW_STATUSES.includes(this.job.dynamicData.status);
  }

  /**
   * 求人ステータスを「募集中」以外から「募集中」へ手動で変更しようとしているかどうか。
   * 「募集中」への変更はAZチェック完了時のみを正規のフローとするため、この画面からの保存は許可しない。
   */
  private get isIllegalStatusChangeToRecruiting(): boolean {
    if (!this.job) {
      return false;
    }
    return this.originalStatus !== STATUS_RECRUITING && this.job.dynamicData.status === STATUS_RECRUITING;
  }

  constructor(
    private dynamicService: DynamicFieldService,
    private datePipe: SafeDatePipe,
    private dialog: DialogService,
    private jobApiService: JobApiService,
    private companyApiService: CompanyApiService,
    private readonly authService: AuthService,
    public readonly userTeamProvider: UserTeamInjectorProvider,
    private salaryTableRowsService: SalaryTableRowsService,
  ) {
    this.salaryTableRowsService.init(() => this.job.dynamicData.salaryTable);
  }

  ngOnInit() {
    this.fieldSubscription = this.dynamicService.fieldUpdateEvent.subscribe(() => {
      this.init();
    });
  }

  private init(): void {
    this.headMeta = {
      disabled: this.readonly,
      initTouched: !this.readonly,
      groups: [
        {
          class: 'oneliner',
          rows: [
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'status'), 'dynamicData'),
            {
              title: '更新者',
              class: 'fill',
              fields: [
                {
                  type: 'label',
                  name: 'updateUserId',
                  supplier: () => (this.job ? this.userTeamProvider.getUserTeamNameById(this.job.updateUserId) : '-'),
                },
              ],
            },
            {
              title: '入力日',
              fields: [
                {
                  type: 'label',
                  name: 'registeredAt',
                  supplier: (val) => this.datePipe.transform(val),
                },
              ],
            },
            {
              title: '更新日',
              fields: [
                {
                  type: 'label',
                  name: 'lastUpdatedAt',
                  supplier: (val) => this.datePipe.transform(val),
                },
              ],
            },
          ],
        },
      ],
    };

    this.leftMeta = {
      disabled: this.readonly,
      initTouched: !this.readonly,
      groups: [
        {
          title: '概要',
          class: 'form__group--green-title-border',
          rows: [
            {
              title: '企業',
              fields: [
                {
                  name: 'enterpriseId',
                  type: 'label',
                  supplier: () => `${this.job.frontEnterpriseId}-${this.job.enterpriseName}`,
                },
              ],
            },
            {
              title: '部署',
              fields: [
                {
                  name: 'enterpriseDepartmentId',
                  type: 'label',
                  options: [],
                  allowOn: { enterpriseId: null },
                  supplier: (value: any, callType: SupplierCallType, getValue?: (key: string) => any) => {
                    const linkValue = getValue('enterpriseId');
                    return linkValue
                      ? this.companyApiService.getDepartments(this.job.enterpriseId).pipe(
                          map((v) => {
                            const ret = v.enterpriseDepartments
                              .map((e) => {
                                e.dynamicData.id = e.id;
                                this.enterpriseDepartmentUsers[e.id] = e.enterpriseDepartmentUsers;
                                return e.dynamicData;
                              })
                              .find((d) => d.id === this.job.enterpriseDepartmentId) || {
                              name: '',
                              id: '',
                            };
                            this.rightMeta.groups = [...this.rightMeta.groups];
                            return `${ret.id}-${ret.name}`;
                          }),
                        )
                      : null;
                  },
                  validators: { required: true },
                },
              ],
            },
            ...this.dynamicService.getFormRows(
              { ...this.dynamicService.getDefinition('job', 'position'), displayType: 'textarea' },
              'dynamicData',
            ),
            ...this.dynamicService.getFormRows(
              { ...this.dynamicService.getDefinition('job', 'tagline'), displayType: 'textarea' },
              'dynamicData',
            ),
          ],
        },
        {
          title: '職務内容',
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'jobType1'), 'dynamicData', 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'jobType2'), 'dynamicData', 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'jobType3'), 'dynamicData', 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'itTypeCareer'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'itTypeArea'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'itAppealFlag'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'pgExperience'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'salesJobFlag'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'salesJobProduct'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'descriptionMainBody'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'description1Title'), 'dynamicData', 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'description1Body'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'description2Title'), 'dynamicData', 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'description2Body'), 'dynamicData'),
          ],
        },
        {
          title: '勤務先',
          class: 'form__group--green-title-border',
          rows: [
            ...(() => {
              const displayRow = this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'workplace'), 'dynamicData').find((row) => {
                return !!row && row.fields[0].name === 'dynamicData.workplace.address1';
              });
              // 勤務先住所は「勤務地(雇入れ直後)」としてaddress1のみを表示する
              // address1に求人票に表示する住所を全て記載する運用（例：東京都〇〇区〇〇1-2-3）
              if (displayRow) {
                displayRow.title = '勤務地(雇入れ直後)';
              }
              return displayRow ? [displayRow] : [];
            })(),
            ...(() => {
              const rows = this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'workplaceRemarks'), 'dynamicData');
              rows[0].title = '勤務地(変更の範囲)';
              return rows;
            })(),
            {
              title: '勤務地(都道府県)',
              class: 'bg-yellow',
              fields: [
                {
                  type: 'prefecture-area',
                  name: 'dynamicData.workplacePrefectures',
                  class: 'full',
                },
              ],
            },
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'transfer'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'jobTransfer'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'firstPlaceOfAssignment'), 'dynamicData'),
            ...(() => {
              const typeRow = this.dynamicService.getFormRows(
                this.dynamicService.getDefinition('job', 'passiveSmokingMeasureType'),
                'dynamicData',
                'full',
              )[0];
              typeRow.fields[0].linkTo = ['dynamicData.passiveSmokingMeasureRule'];
              const ruleRow = this.dynamicService.getFormRows(
                this.dynamicService.getDefinition('job', 'passiveSmokingMeasureRule'),
                'dynamicData',
                'full',
              )[0];
              ruleRow.fields[0].supplier = (value, callType, getValue) => {
                const linkValue = getValue('dynamicData.passiveSmokingMeasureType');
                switch (linkValue) {
                  case '第一種施設（学校・官公庁・病院等）':
                    return { options: ['敷地内禁煙', '敷地内禁煙（喫煙場所：有）', 'その他'] };
                  case '第二種施設（事業所・ホテル・旅館・飲食店等）':
                    return {
                      options: [
                        '屋内禁煙',
                        '屋内禁煙（喫煙場所：有）',
                        '屋内原則禁煙（喫煙室：有）',
                        '屋内原則禁煙（喫煙可の宿泊室：有）',
                        'その他',
                      ],
                    };
                  case '喫煙目的施設（バー・スナック・たばこ販売店等）':
                    return { options: ['屋内喫煙可', '屋内喫煙可（喫煙室内に限る）', 'その他'] };
                  case '旅客運送事業（バス・飛行機・電車・船舶）':
                    return { options: ['車内禁煙', '車内原則禁煙（喫煙室：有）', 'その他'] };
                  case '屋外（第一種施設の敷地内は除く）':
                    return { options: ['屋外のため規定なし'] };
                }
              };
              ruleRow.fields[0].allowOn = { 'dynamicData.passiveSmokingMeasureType': null };
              return [typeRow, ruleRow];
            })(),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'passiveSmokingMeasureRemarks'), 'dynamicData'),
          ],
        },
        {
          title: '選考内容',
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'requirement'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'certificates'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'languageSkill'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'interviewDescription'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'aptitudeTest'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'interviewCount'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'requireDocument'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'additionalQuestionFromCompany1'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'additionalQuestionFromCompany2'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'additionalQuestionFromCompany3'), 'dynamicData'),
          ],
        },
        {
          title: 'アピールポイント',
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'appealMainBody'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'appeal1Title'), 'dynamicData', 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'appeal1Body'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'appeal2Title'), 'dynamicData', 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'appeal2Body'), 'dynamicData'),
          ],
        },
        {
          title: '選考情報',
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'resumeRequiredOnRecommend'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'hasSeminar'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'screeningArea'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'workArea'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'webBasedScreening'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'seminarNote1'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'seminarNote2'), 'dynamicData'),
          ],
        },
        {
          title: '性格・タイプ',
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'characterAndType1'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'characterAndType2'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'characterAndType3'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'characterAndType4'), 'dynamicData'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'characterAndType5'), 'dynamicData'),
          ],
        },
        {
          title: '調整フローリンク',
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'adjustmentFlowLink'), 'dynamicData', 'full'),
          ],
        },
      ],
    };
    this.rightMeta = {
      disabled: this.readonly,
      initTouched: !this.readonly,
      groups: [
        {
          title: '担当',
          class: 'form__group--green-title-border',
          rows: this.getUserRows(),
        },
        {
          title: 'ステータス',
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'recommendationDateKind')),
            (() => {
              const row = this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'recommendationDate'))[0];
              row.fields[0].allowOn = { recommendationDateKind: null };
              row.fields[0].validators.required = true;
              return row;
            })(),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'rank'), null, 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'recruitYear'), null, 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'agentServiceHire'), null, 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'partnerHire'), null, 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'turnaroundDay'), null, 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'exclusiveJob'), null, 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'dedicatedHire'), null, 'half'),
          ],
        },
        {
          title: '採用条件',
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'communicationSkill')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'impressionAndCharm')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'lastAcademicRecord'), null, 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'gender'), null, 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'afterGraduate')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'postGraduate')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'universityLevel'), null, 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'academicFieldType'), null, 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'academicCourseType')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'firstPriorityFaculty')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'secondPriorityFaculty')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'scienceProjectFlag')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'scienceRecruitmentCategory')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'roninYearType')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'repeatYearType')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'exceptionalExperience')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'internationalStudent')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'pastGlobalCountry')),
          ],
        },
        {
          title: '待遇・福利厚生',
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'employmentMethod')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'hasTrial')),
            (() => {
              const row = this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'trialMonth'))[0];
              row.fields[0].allowOn = { hasTrial: '有' };
              row.fields[0].validators.required = true;
              return row;
            })(),
            (() => {
              const row = this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'trialDescription'))[0];
              row.fields.push({
                type: 'label',
                name: 'trialDescriptionNote',
                class: 'pre-line',
                default: '※試用期間中は労働条件などと試用期間終了後の労働条件が異なる場合はそれぞれ労働条件などを記載してください。',
              });
              return row;
            })(),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'employmentPeriod')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'workingHourRange'), null, 'half'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'workingHourComment')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'breakHour'), null, 'full'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'overtimeType')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'overtimeHours')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'overtimeWork')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'paymentMethod')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'promotion')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'bonus'), null, 'full'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'workhourType'), null, 'half'),
            (() => {
              const row = this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'hasSubmittedToLaborOfficeForDeemedWorkingHours'))[0];
              row.titleStyle = { 
                'max-width': '160px',
                'white-space': 'pre-wrap',
              };
              return row;
            })(),
            ...(() => {
              const rows = this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'salaryTable'));
              this.salaryTableRowsService.rows = rows;
              this.salaryTableRowsService.wire();
              return rows;
            })(),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'monthlyScheduledWorkingHours')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'annualScheduledWorkingHours')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'annualHolidays')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'holidayType')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'weekendDescription')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'insurance')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'commuterDescription'), null, 'full'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'supplementDescription')), // 各種手当
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'benefitDescription')),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'flexibleWorkingFlag')),
          ],
        },
      ],
    };

    this.screeningMeta1 = {
      disabled: this.readonly,
      initTouched: !this.readonly,
      groups: [
        {
          title: 'セミナー・面接情報',
          collapsedTitle: 'セミナー選考情報',
          toggleButtonLabel: '入力',
          toggledButtonLabel: '削除',
          toggledButtonAction: () => this.clearInfo(this.job.dynamicData.screeningInfoSeminar),
          class: 'form__group--green-title-border',
          collapsable: true,
          expanded: this.job != null && Object.values(this.job.dynamicData.screeningInfoSeminar || {}).find((v) => !!v) != null,
          rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'screeningInfoSeminar')),
        },
        {
          collapsedTitle: '1次選考情報',
          toggleButtonLabel: '入力',
          toggledButtonLabel: '削除',
          toggledButtonAction: () => this.clearInfo(this.job.dynamicData.screeningInfo1),
          class: 'form__group--no-margin',
          collapsable: true,
          expanded: this.job != null && Object.values(this.job.dynamicData.screeningInfo1 || {}).find((v) => !!v) != null,
          rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'screeningInfo1')),
        },
        {
          collapsedTitle: '2次選考情報',
          toggleButtonLabel: '入力',
          toggledButtonLabel: '削除',
          toggledButtonAction: () => this.clearInfo(this.job.dynamicData.screeningInfo2),
          class: 'form__group--no-margin',
          collapsable: true,
          expanded: this.job != null && Object.values(this.job.dynamicData.screeningInfo2 || {}).find((v) => !!v) != null,
          rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'screeningInfo2')),
        },
      ],
    };
    this.screeningMeta2 = {
      disabled: this.readonly,
      initTouched: !this.readonly,
      groups: [
        {
          collapsedTitle: '3次選考情報',
          toggleButtonLabel: '入力',
          toggledButtonLabel: '削除',
          toggledButtonAction: () => this.clearInfo(this.job.dynamicData.screeningInfo3),
          class: '',
          collapsable: true,
          expanded: this.job != null && Object.values(this.job.dynamicData.screeningInfo3 || {}).find((v) => !!v) != null,
          rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'screeningInfo3')),
        },
        {
          collapsedTitle: '4次選考情報',
          toggleButtonLabel: '入力',
          toggledButtonLabel: '削除',
          toggledButtonAction: () => this.clearInfo(this.job.dynamicData.screeningInfo4),
          class: 'form__group--no-margin',
          collapsable: true,
          expanded: this.job != null && Object.values(this.job.dynamicData.screeningInfo4 || {}).find((v) => !!v) != null,
          rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'screeningInfo4')),
        },
        {
          collapsedTitle: '5次以降選考情報',
          toggleButtonLabel: '入力',
          toggledButtonLabel: '削除',
          toggledButtonAction: () => this.clearInfo(this.job.dynamicData.screeningInfo5),
          class: 'form__group--no-margin',
          collapsable: true,
          expanded: this.job != null && Object.values(this.job.dynamicData.screeningInfo5 || {}).find((v) => !!v) != null,
          rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'screeningInfo5')),
        },
      ],
    };

    this.interviewMeta1 = {
      disabled: this.readonly,
      initTouched: !this.readonly,
      groups: [
        {
          collapsedTitle: 'セミナー案内',
          toggleButtonLabel: '入力',
          toggledButtonLabel: '削除',
          toggledButtonAction: () => this.clearInfo(this.job.dynamicData.interviewInfoSeminar),
          class: 'form__group--no-margin no-title-column',
          collapsable: true,
          expanded: this.job != null && Object.values(this.job.dynamicData.interviewInfoSeminar || {}).find((v) => !!v) != null,
          rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'interviewInfoSeminar')),
        },
        {
          collapsedTitle: '面接案内1',
          toggleButtonLabel: '入力',
          toggledButtonLabel: '削除',
          toggledButtonAction: () => this.clearInfo(this.job.dynamicData.interviewInfo1),
          class: 'form__group--no-margin no-title-column',
          collapsable: true,
          expanded: this.job != null && Object.values(this.job.dynamicData.interviewInfo1 || {}).find((v) => !!v) != null,
          rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'interviewInfo1')),
        },
        {
          collapsedTitle: '面接案内2',
          toggleButtonLabel: '入力',
          toggledButtonLabel: '削除',
          toggledButtonAction: () => this.clearInfo(this.job.dynamicData.interviewInfo2),
          class: 'form__group--no-margin no-title-column',
          collapsable: true,
          expanded: this.job != null && Object.values(this.job.dynamicData.interviewInfo2 || {}).find((v) => !!v) != null,
          rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'interviewInfo2')),
        },
      ],
    };

    this.interviewMeta2 = {
      disabled: this.readonly,
      initTouched: !this.readonly,
      groups: [
        {
          collapsedTitle: '面接案内3',
          toggleButtonLabel: '入力',
          toggledButtonLabel: '削除',
          toggledButtonAction: () => this.clearInfo(this.job.dynamicData.interviewInfo3),
          class: 'form__group--no-margin no-title-column',
          collapsable: true,
          expanded: this.job != null && Object.values(this.job.dynamicData.interviewInfo3 || {}).find((v) => !!v) != null,
          rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'interviewInfo3')),
        },
        {
          collapsedTitle: '面接案内4',
          toggleButtonLabel: '入力',
          toggledButtonLabel: '削除',
          toggledButtonAction: () => this.clearInfo(this.job.dynamicData.interviewInfo4),
          class: 'form__group--no-margin no-title-column',
          collapsable: true,
          expanded: this.job != null && Object.values(this.job.dynamicData.interviewInfo4 || {}).find((v) => !!v) != null,
          rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'interviewInfo4')),
        },
        {
          collapsedTitle: '面接案内5以降',
          toggleButtonLabel: '入力',
          toggledButtonLabel: '削除',
          toggledButtonAction: () => this.clearInfo(this.job.dynamicData.interviewInfo5),
          class: 'form__group--no-margin no-title-column',
          collapsable: true,
          expanded: this.job != null && Object.values(this.job.dynamicData.interviewInfo5 || {}).find((v) => !!v) != null,
          rows: this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'interviewInfo5')),
        },
      ],
    };

    const customs = this.dynamicService.getDefinitions('job').filter((def) => def.isCustomField);
    if (customs.length) {
      this.customMeta = {
        disabled: this.readonly,
        initTouched: !this.readonly,
        groups: [
          {
            title: 'カスタムフィールド',
            class: 'form__group--green-title-border',
            rows: (customs.map((c) => this.dynamicService.getFormRows(c)).flatten() as unknown) as RowMeta[],
          },
        ],
      };
    }

    this.remarksMeta = {
      disabled: this.readonly,
      initTouched: !this.readonly,
      groups: [
        {
          title: 'その他',
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'remarks'), null, 'full'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'secondMatchTarget'), null, 'full'),
            ...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'excludeSimilarFlg'), null),
          ],
        },
      ],
    };

    this.remarksMeta1 = {
      disabled: this.readonly,
      initTouched: !this.readonly,
      groups: [
        {
          class: 'form__group--no-title',
          rows: [...this.dynamicService.getFormRows(this.dynamicService.getDefinition('job', 'confirmationRemarks'), null, 'full')],
        },
      ],
    };
  }

  ngOnChanges(changes) {
    if (changes.job && this.job) {
      this.fetchJobScreeningInfoList();
      this.job.dynamicData.raId = this.job.enterpriseDepartmentUsers
        .filter((user) => user.type === EnterpriseDepartmentUserType.RA)
        .map((user) => user.userId);
      this.job.dynamicData.paId = this.job.enterpriseDepartmentUsers
        .filter((user) => user.type === EnterpriseDepartmentUserType.PA)
        .map((user) => user.userId);
      this.job.dynamicData.asId = this.job.enterpriseDepartmentUsers
        .filter((user) => user.type === EnterpriseDepartmentUserType.アシ)
        .map((user) => user.userId);
      if (!this.job.dynamicData.workplacePrefectures) {
        this.job.dynamicData.workplacePrefectures = [];
      }
      if (!this.job.dynamicData.salaryTable) {
        this.job.dynamicData.salaryTable = {};
      }
      this.companyApiService.getDetail(this.job.enterpriseId).subscribe((company) => {
        this.job.dynamicData.company = company.id;
      });
      this.normalizeJobDynamicDataArrayValues();
      this.originalStatus = this.job.dynamicData.status;
      this.onFormChanged('recommendationDateKind');
      this.onFormChanged('hasTrial');
      this.salaryTableRowsService.syncVisibility();
      this.refreshSalaryTableDescriptionValidation();
      this.onFormChanged('workhourType');
      if (this.screeningMeta1) {
        this.screeningMeta1.groups[0].expanded = Object.values(this.job.dynamicData.screeningInfoSeminar || {}).find((v) => !!v) != null;
        this.screeningMeta1.groups[1].expanded = Object.values(this.job.dynamicData.screeningInfo1 || {}).find((v) => !!v) != null;
        this.screeningMeta1.groups[2].expanded = Object.values(this.job.dynamicData.screeningInfo2 || {}).find((v) => !!v) != null;
      }
      if (this.screeningMeta2) {
        this.screeningMeta2.groups[0].expanded = Object.values(this.job.dynamicData.screeningInfo3 || {}).find((v) => !!v) != null;
        this.screeningMeta2.groups[1].expanded = Object.values(this.job.dynamicData.screeningInfo4 || {}).find((v) => !!v) != null;
        this.screeningMeta2.groups[2].expanded = Object.values(this.job.dynamicData.screeningInfo5 || {}).find((v) => !!v) != null;
      }
      if (this.interviewMeta1) {
        this.interviewMeta1.groups[0].expanded =
          this.job.dynamicData.interviewInfoSeminar && this.job.dynamicData.interviewInfoSeminar.description;
        this.interviewMeta1.groups[1].expanded = this.job.dynamicData.interviewInfo1 && this.job.dynamicData.interviewInfo1.description;
        this.interviewMeta1.groups[2].expanded = this.job.dynamicData.interviewInfo2 && this.job.dynamicData.interviewInfo2.description;
      }
      if (this.interviewMeta2) {
        this.interviewMeta2.groups[0].expanded = this.job.dynamicData.interviewInfo3 && this.job.dynamicData.interviewInfo3.description;
        this.interviewMeta2.groups[1].expanded = this.job.dynamicData.interviewInfo4 && this.job.dynamicData.interviewInfo4.description;
        this.interviewMeta2.groups[2].expanded = this.job.dynamicData.interviewInfo5 && this.job.dynamicData.interviewInfo5.description;
      }
    }
  }

  ngOnDestroy() {
    if (this.fieldSubscription) {
      this.fieldSubscription.unsubscribe();
      this.fieldSubscription = null;
    }
    if (this.jobScreeningInfoSubscription) {
      this.jobScreeningInfoSubscription.unsubscribe();
      this.jobScreeningInfoSubscription = null;
    }
  }

  onValidityChange(validity: boolean, index: number): void {
    this.validityArray[index] = validity;
    this.validity = this.validityArray.find((v) => !v) == null;
  }

  getUserRows(): RowMeta[] {
    return [
      ...this.dynamicService.getFormRows(
        { fieldName: 'raId', label: 'RA', fieldType: 'multi-user', validationStyle: { max: 1 } },
        null,
        null,
        (user) => {
          if (!this.enterpriseDepartmentUsers[this.job.enterpriseDepartmentId]) {
            return false;
          }
          return !!this.enterpriseDepartmentUsers[this.job.enterpriseDepartmentId].find(
            (depUser) => depUser.userId === user.id && depUser.type === EnterpriseDepartmentUserType.RA,
          );
        },
      ),
      ...this.dynamicService.getFormRows(
        { fieldName: 'paId', label: 'PA', fieldType: 'multi-user', validationStyle: { max: 1 } },
        null,
        null,
        (user) => {
          if (!this.enterpriseDepartmentUsers[this.job.enterpriseDepartmentId]) {
            return false;
          }
          return !!this.enterpriseDepartmentUsers[this.job.enterpriseDepartmentId].find(
            (depUser) => depUser.userId === user.id && depUser.type === EnterpriseDepartmentUserType.PA,
          );
        },
      ),
      ...this.dynamicService.getFormRows(
        {
          fieldName: 'asId',
          label: 'アシスタント',
          fieldType: 'multi-user',
          validationStyle: { max: 10 },
        },
        null,
        null,
        (user) => {
          if (!this.enterpriseDepartmentUsers[this.job.enterpriseDepartmentId]) {
            return false;
          }
          return !!this.enterpriseDepartmentUsers[this.job.enterpriseDepartmentId].find(
            (depUser) => depUser.userId === user.id && depUser.type === EnterpriseDepartmentUserType.アシ,
          );
        },
      ),
    ];
  }

  onActionButton(event: any): void {
    event.target.disabled = true;
    this.companyApiService.getDepartments(this.job.enterpriseId).subscribe(
      (departments) => {
        departments.enterpriseDepartments.forEach((department) => {
          if (department.id === this.job.enterpriseDepartmentId) {
            this.job.dynamicData.workplace = { ...department.dynamicData.address };
          }
        });
        event.target.disabled = false;
      },
      () => (event.target.disabled = false),
    );
  }
  onFormChanged(key: string): void {
    if (key === 'recommendationDateKind' && this.rightMeta) {
      this.rightMeta.groups[1].rows[1].showRequired = this.job && this.job.dynamicData.recommendationDateKind;
    } else if (key === 'hasTrial' && this.rightMeta) {
      this.rightMeta.groups[3].rows[2].showRequired = this.job && this.job.dynamicData.hasTrial === '有';
    } else if (key === 'salaryTable.fixedOvertimeFee' && this.job && this.job.dynamicData.salaryTable.fixedOvertimeFee === '無') {
      this.clearFixedOvertimeCategoryValues();
      // 固定残業代補足（非編集テキスト）もクリアされるため、文字数上限バリデーションを更新する
      this.refreshSalaryTableDescriptionValidation();
    } else if (key === 'salaryTable.fixedLateNightOvertimeType' && this.job && this.job.dynamicData.salaryTable.fixedLateNightOvertimeType !== '有') {
      this.clearFixedLateNightOvertimeCategoryValues();
      // 固定の深夜割増手当有無を'有'以外に変更した際に給与補足に変更が入るため文字数上限バリデーションを更新する
      this.refreshSalaryTableDescriptionValidation();
    } else if (key === 'salaryTable.variableWorkingHoursSystem') {
      // 変形労働時間制を変更した際に給与補足に変更が入るため文字数上限バリデーションを更新する
      this.refreshSalaryTableDescriptionValidation();
    } else if (
      key === 'salaryTable.salaryDescriptionEditable' ||
      key === 'salaryTable.salaryDescriptionSalaryByGraduateCategory' ||
      key === 'salaryTable.salaryDescriptionFixedLateNightOvertime' ||
      key.startsWith('salaryTable.fixedOvertimeDescription')
    ) {
      // 「反映」「短縮反映」「クリア」ボタン押下、または給与補足・固定残業代補足の編集可能欄への入力があった際に文字数上限バリデーションを更新する
      // salaryDescriptionVariableWorkingHoursSystem・salaryDescriptionNonEditableDisplayは対象外とする。
      // これらはフォーム再構築のたびにlinkTo経由で無条件に再設定されchangedが発火するため、
      // ここで拾ってしまうと「再構築→再発火→再構築…」の無限ループになってしまう
      // （variableWorkingHoursSystem自体の変更は上のブランチで既に処理済み）。
      this.refreshSalaryTableDescriptionValidation();
    } else if (key === 'workhourType' && this.job) {
      this.applyDeemedWorkingHoursSystemFixedOvertimeConstraint();
    }
  }

  /**
   * 給与補足・固定残業代補足の文字数上限バリデーション（editable欄のmax・上限超過時の赤枠表示）を再計算し、
   * DynamicFormComponent側のフォーム再構築をトリガーする（rightMeta.groupsの参照を変えてmetadataDifferに検知させる）。
   */
  private refreshSalaryTableDescriptionValidation(): void {
    this.salaryTableRowsService.updateDescriptionValidation();
    if (this.rightMeta) {
      this.rightMeta.groups = [...this.rightMeta.groups];
    }
  }

  save(): void {
    if (this.isIllegalStatusChangeToRecruiting) {
      this.openIllegalStatusChangeToRecruitingDialog(
        '求人ステータスを手動で「募集中」へ変更することはできません。\nチェックボタンからチェックを実施してください。'
      );
      return;
    }
    this.saveAsObservable().subscribe((response) => this.jobApiService.refreshEvent.emit());
  }

  azCheck(): void {
    if (this.isIllegalStatusChangeToRecruiting) {
      this.openIllegalStatusChangeToRecruitingDialog(
        '求人ステータスを手動で「募集中」へ変更することはできません。\nステータスを変更せずにチェックを実施してください。'
      );
      return;
    }

    const isInConsultationOnCreate = this.isInConsultation(this.job.dynamicData.azConsultingInfoOnCreate);
    const isInConsultationBeforeAz = this.isInConsultation(this.job.dynamicData.azConsultingInfoBeforeAz);
    if (isInConsultationOnCreate || isInConsultationBeforeAz) {
      const consultingInfoSavedTiming: JobAzCheckTiming = isInConsultationOnCreate ? 'onCreate' : 'beforeAz';

      // 管理者RA = ダッシュボードタイプ求人マネージャー かつ 管理者権限あり
      const isAdminRa = this.authService.loginUser && this.authService.loginUser.dashboardType === DashboardType.RA_Manager && this.authService.loginUser.role === 1;
      if (isAdminRa) {
        this.dialog.open(JobAzCheckConsultationResultDialogComponent, {
          data: { job: this.job, savedTiming: consultingInfoSavedTiming },
        });
      } else {
        PopupControlComponent.instance.open({
          title: '企画相談中です',
          content: '企画相談中のため操作できません。\n管理者へ操作を依頼してください。',
          confirmText: 'OK',
          confirmCallback: () => false,
        });
      }
      return;
    }

    this.needsInvalidateUrl().subscribe((shouldShowReturnConfirmDialog) => {
      // URLの無効化が必要な場合 or Excel送信 かつ 求人ステータスが「企業確認待ち」の場合 返却確認ダイアログを表示する
      //  => URLの無効化, 企業確認済みステータスへ変更（企業確認待ちの場合のみ） を実施する
      if (shouldShowReturnConfirmDialog || (this.job.dynamicData.jobCompanySharedFormat === 'excel' && this.originalStatus === '企業確認待ち')) {
        PopupControlComponent.instance.open({
          title: '求人票の返却確認',
          content: '企業の確認（返却）は完了していますか？',
          confirmText: 'はい',
          confirmCallback: () => {
            return this.saveAsObservable(true).pipe(
              switchMap(() => this.jobApiService.confirmCompanyReturn(this.job.id)),
              tap(() => {
                this.jobApiService.refreshEvent.emit();
                this.openAzCheckDialogBeforeAz();
              }),
            );
          },
          multiConfirm: [
            {
              confirmText: 'いいえ',
              confirmCallback: () => this.saveAndProceed(() => this.openAzCheckDialogOnCreate()),
            },
          ],
          cancelText: 'キャンセル',
        });
        return;
      }

      this.saveAndProceed(() => {
        if (this.isAzCheckOnCreate) {
          this.openAzCheckDialogOnCreate();
        } else {
          this.openAzCheckDialogBeforeAz();
        }
      }).subscribe();
    });
  }

  azCheckAfterAz(): void {
    if (this.isIllegalStatusChangeToRecruiting) {
      this.openIllegalStatusChangeToRecruitingDialog(
        '求人ステータスを手動で「募集中」へ変更することはできません。\nステータスを変更せずにチェックを実施してください。'
      );
      return;
    }

    const isInConsultationAfterAz1st = this.isInConsultation(this.job.dynamicData.azConsultingInfoAfterAz1st);
    const isInConsultationAfterAz2nd = this.isInConsultation(this.job.dynamicData.azConsultingInfoAfterAz2nd);
    if (isInConsultationAfterAz1st || isInConsultationAfterAz2nd) {
      const consultingInfoSavedTiming: JobAzCheckTiming = isInConsultationAfterAz1st ? 'afterAz1st' : 'afterAz2nd';

      // 管理者RA = ダッシュボードタイプ求人マネージャー かつ 管理者権限あり
      const isAdminRa = this.authService.loginUser && this.authService.loginUser.dashboardType === DashboardType.RA_Manager && this.authService.loginUser.role === 1;
      if (isAdminRa) {
        this.dialog.open(JobAzCheckConsultationResultDialogComponent, {
          data: { job: this.job, savedTiming: consultingInfoSavedTiming },
        });
      } else {
        PopupControlComponent.instance.open({
          title: '企画相談中です',
          content: '企画相談中のため操作できません。\n管理者へ操作を依頼してください。',
          confirmText: 'OK',
          confirmCallback: () => false,
        });
      }
      return;
    }

    this.needsInvalidateUrl().subscribe((shouldShowReturnConfirmDialog) => {
      // URLの無効化が必要な場合 or Excel送信 かつ 求人ステータスが「企業確認待ち」の場合 返却確認ダイアログを表示する
      //  => URLの無効化, 企業確認済みステータスへ変更（企業確認待ちの場合のみ） を実施する
      if (shouldShowReturnConfirmDialog || (this.job.dynamicData.jobCompanySharedFormat === 'excel' && this.originalStatus === '企業確認待ち')) {
        PopupControlComponent.instance.open({
          title: '求人票の返却確認',
          content: '企業の確認（返却）は完了していますか？',
          confirmText: 'はい',
          confirmCallback: () => {
            return this.saveAsObservable(true).pipe(
              switchMap(() => this.jobApiService.confirmCompanyReturn(this.job.id)),
              tap(() => {
                this.jobApiService.refreshEvent.emit();
                this.openAzCheckDialogAfterAz2nd();
              }),
            );
          },
          multiConfirm: [
            {
              confirmText: 'いいえ',
              confirmCallback: () => this.saveAndProceed(() => this.openAzCheckDialogAfterAz1st()),
            },
          ],
          cancelText: 'キャンセル',
        });
        return;
      }

      this.saveAndProceed(() => {
        if (this.isAzCheckAfterAz1st) {
          this.openAzCheckDialogAfterAz1st();
        } else {
          this.openAzCheckDialogAfterAz2nd();
        }
      }).subscribe();
    });
  }

  /**
   * 無効化すべき有効な企業向け確認URLが残っているかどうかを判定する
   * 
   * 以下の条件全て満たす場合無効化が必要と判断する
   * - 求人票共有形式がURL
   * - 企業返却日が入っていない
   * - 有効なURLが存在する（JobCompanyAzCheckInfoが論理削除されていない）
   */
  private needsInvalidateUrl(): Observable<boolean> {
    if (this.job.dynamicData.jobCompanySharedFormat !== 'url' || this.job.dynamicData.jobCompanyAzCheckReturnedAt) {
      return of(false);
    }

    // 求人票共有形式がURLで、かつ企業返却日が入っていない場合のみ、実際にJobCompanyAzCheckInfoが有効か（未論理削除か）をAPIで確認する
    return this.jobApiService.hasValidCompanyUrl(this.job.id).pipe(map((res) => res.valid));
  }

  private saveAndProceed(onSuccess: () => void): Observable<any> {
    return this.saveAsObservable(true).pipe(
      tap(() => {
        this.jobApiService.refreshEvent.emit();
        onSuccess();
      }),
    );
  }

  private openIllegalStatusChangeToRecruitingDialog(content: string): void {
    PopupControlComponent.instance.open({
      title: '求人ステータスの変更について',
      content,
      confirmText: 'OK',
      confirmCallback: () => false,
    });
  }

  private openAzCheckDialogOnCreate(): void {
    this.dialog.open(JobAzCheckDialogOnCreateComponent, {
      data: { job: this.job },
    });
  }

  private openAzCheckDialogBeforeAz(): void {
    this.dialog.open(JobAzCheckDialogBeforeAzComponent, {
      data: { job: this.job },
    });
  }

  private openAzCheckDialogAfterAz1st(): void {
    this.dialog.open(JobAzCheckDialogAfterAz1stComponent, {
      data: { job: this.job },
    });
  }

  private openAzCheckDialogAfterAz2nd(): void {
    this.dialog.open(JobAzCheckDialogAfterAz2ndComponent, {
      data: { job: this.job },
    });
  }

  reflect(): void {
    if (this.isIllegalStatusChangeToRecruiting) {
      this.openIllegalStatusChangeToRecruitingDialog(
        '求人ステータスを手動で「募集中」へ変更することはできません。\nステータスを変更せずに返却確認を実施してください。'
      );
      return;
    }

    this.saveAndProceed(() => {
      this.dialog.open(JobAzCheckDialogApplyCompanyChangesComponent, {
        data: { job: this.job },
      });
    }).subscribe();
  }

  clearInfo(data: any): boolean {
    if (data == null) {
      return;
    }
    Object.keys(data || {}).forEach((key) => (data[key] = null));
  }

  public openAddNewSubScreeningInfoDialog():void {
    this.dialogRef = this.dialog.open(JobScreeningInfoCreateDialogComponent, {
      data: {
        job: this.job,
        toBeExcludedJobScreeningInfoTypes: [],
      }
    });
    let closeSubscription: Subscription;
    const unsubscribe = () => {
      if (closeSubscription) {
        closeSubscription.unsubscribe();
      }
    };
    closeSubscription = this.dialogRef.afterClosed.subscribe((res) => {
      this.dialogRef = null;
      // 閉じたタイミングで更新
      this.fetchJobScreeningInfoList();
      unsubscribe();
    });
  }

  public openEditSubScreeningInfoDialog(job: Job, jobScreeningInfoData: JobScreeningInfo):void {

    this.dialogRef = this.dialog.open(JobScreeningInfoEditDialogComponent, {
      data: {
        job,
        jobScreeningInfoData,
      }
    });
    let closeSubscription: Subscription;
    const unsubscribe = () => {
      if (closeSubscription) {
        closeSubscription.unsubscribe();
      }
    };
    closeSubscription = this.dialogRef.afterClosed.subscribe((res) => {
      this.dialogRef = null;
      // 閉じたタイミングで更新
      this.fetchJobScreeningInfoList();
      unsubscribe();
    });
  }
  private fetchJobScreeningInfoList(): void {
    if (!this.job || !this.job.id) return;

    if (this.jobScreeningInfoSubscription) {
      this.jobScreeningInfoSubscription.unsubscribe();
      this.jobScreeningInfoSubscription = null;
    }

    this.jobScreeningInfoSubscription = this.jobApiService
      .getJobScreeningInfoList(this.job.id)
      .subscribe((res) => {
        // null/undefined を除去
        this.jobScreeningInfoList = (res || []).filter((x) => !!x && !!x.type);

        // 画面反映（subScreeningInfoMeta1 を作り直す）
        this.subScreeningInfoMeta1 = this.buildSubScreeningInfoFormMeta();
        this.subScreeningInfoMeta1 = {
          ...this.buildSubScreeningInfoFormMeta()
        }
      });
  }
  /** 取得結果から subScreeningInfoMeta1 を構築し直す */
  private buildSubScreeningInfoFormMeta(): FormMeta {
    const baseGroup: GroupMeta = {
      toggleButtonLabel: '編集',
      toggledButtonLabel: '編集',
      class: 'form__group--green-title-border',
      collapsable: true,
      expanded: true,
      lockToggling: true,
      rows: [],
    };

    const groups: GroupMeta[] =
      this.jobScreeningInfoList &&
      this.jobScreeningInfoList.map((info) => {
        return {
          ...baseGroup,
          collapsedTitle: `${info.type}${info.no}選考情報`,
          toggledButtonAction: () => this.openEditSubScreeningInfoDialog(this.job, info),
        };
      })
      || []
    ;

    return {
      disabled: this.readonly,
      initTouched: !this.readonly,
      groups: [
        {
          title: 'サブステータス情報',
          injectToHeader: this.addNewSubScreeningInfoTemplate,
          class: 'form__group--green-title-border',
          rows: [],
        },
        ...groups
      ],
    };
  }

  private normalizeJobDynamicDataArrayValues(): void {
    // dynamic_field の default_value が配列形式（例: ["有"]）で保存されているため、新規データは配列として渡される。
    // UIは文字列前提のためラジオボタン等が未選択に見える問題の対応として、配列の場合は先頭要素の文字列に正規化する。
    const fields = ['overtimeType', 'hasTrial', 'promotion', 'secondMatchTarget', 'status'];
    for (const field of fields) {
      const value = this.job.dynamicData[field];
      if (Array.isArray(value) && value.length > 0) {
        this.job.dynamicData[field] = value[0];
      }
    }
  }

  private saveAsObservable(silent: boolean = false): Observable<any> {
    const jobData: any = deepClone(this.job);
    delete jobData.enterpriseDepartmentUsers;
    delete jobData.dynamicData.raId;
    delete jobData.dynamicData.paId;
    delete jobData.dynamicData.asId;
    jobData.enterpriseDepartmentUserIds = [
      ...this.job.dynamicData.raId.map(
        (user) =>
          this.enterpriseDepartmentUsers[this.job.enterpriseDepartmentId].find(
            (depUser) => depUser.userId === user && depUser.type === EnterpriseDepartmentUserType.RA,
          ).id,
      ),
      ...this.job.dynamicData.paId.map(
        (user) =>
          this.enterpriseDepartmentUsers[this.job.enterpriseDepartmentId].find(
            (depUser) => depUser.userId === user && depUser.type === EnterpriseDepartmentUserType.PA,
          ).id,
      ),
      ...this.job.dynamicData.asId.map(
        (user) =>
          this.enterpriseDepartmentUsers[this.job.enterpriseDepartmentId].find(
            (depUser) => depUser.userId === user && depUser.type === EnterpriseDepartmentUserType.アシ,
          ).id,
      ),
    ];
    return this.jobApiService.update(this.job.id, jobData, silent);
  }

  /**
   * 企画相談中かどうかを判定する
   * - 未相談やミドル許容フラグが設定済みの場合 : false
   * - その他の場合 : true
   * @param consultingInfo 相談内容
   * @returns 企画相談中かどうか
   */
  private isInConsultation(consultingInfo: JobAzCheckConsultingInfo): boolean {
    // 未相談
    if (!consultingInfo) {
      return false;
    }

    // ミドル許容フラグ設定済み
    if (consultingInfo.middlePermissionFlg != null) {
      return false;
    }

    // 相談内容が空（未相談）
    const consultingItemKeys = Object.keys(consultingInfo.consultingItems || {});
    if (consultingInfo.contactMessage === '' && consultingItemKeys.length === 0) {
      return false;
    }

    // その他の場合 = 相談中
    return true;
  }

  /**
   * 固定残業代（salaryTable.fixedOvertimeFee）を「無」に変更した際、
   * 既入力の固定残業時間・金額（全卒業種別分）と固定残業代補足をクリアする。
   */
  private clearFixedOvertimeCategoryValues(): void {
    clearFixedOvertimeCategoryValues(this.job.dynamicData.salaryTable);
    this.salaryTableRowsService.syncVisibility();
  }

  /**
   * 固定の深夜割増手当（salaryTable.fixedLateNightOvertimeType）を「有→未選択」に変更した際、
   * 固定残業代と同様に、既入力の深夜割増時間・金額（全卒業種別分）と反映済みの給与補足文言をクリアする。
   */
  private clearFixedLateNightOvertimeCategoryValues(): void {
    clearFixedLateNightOvertimeCategoryValues(this.job.dynamicData.salaryTable);
    this.salaryTableRowsService.syncVisibility();
  }

  /**
   * みなし労働時間制の有無（dynamicData.workhourType）が「有」から始まる場合、
   * 固定残業代を「無」に強制してクリアし、固定残業代の入力を非活性にする。「有」以外の場合は活性に戻す。
   */
  private applyDeemedWorkingHoursSystemFixedOvertimeConstraint(): void {
    const disabled = isDeemedWorkingHoursSystemSelected(this.job.dynamicData.workhourType);
    if (disabled) {
      forceFixedOvertimeFeeNoneForDeemedWorkingHours(this.job.dynamicData.salaryTable);
      this.salaryTableRowsService.syncVisibility();
      // 固定残業代を'無'に強制した際に深夜割増手当・固定残業代補足もクリアされるため文字数上限バリデーションを更新する
      this.refreshSalaryTableDescriptionValidation();
    }
    this.salaryTableRowsService.setFixedOvertimeFeeDisabled(disabled);
  }
}
